<div [ngClass]="{ 'p-dataview p-component': true, 'p-dataview-list': layout === 'list', 'p-dataview-grid': layout === 'grid' }" [ngStyle]="style" [class]="styleClass">
  @if (loading) {
    <div class="p-dataview-loading">
      <div class="p-dataview-loading-overlay p-component-overlay">
        <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
      </div>
    </div>
  }
  @if (header || headerTemplate) {
    <div class="p-dataview-header">
      <ng-content select="p-header"></ng-content>
      <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
    </div>
  }
  @if (paginator && totalRecords > rows && ['top', 'both'].includes(paginatorPosition)) {
    <p-paginator
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [pageLinkSize]="pageLinks"
      [alwaysShow]="alwaysShowPaginator"
      (onPageChange)="paginate($event)"
      styleClass="p-paginator-top"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [dropdownAppendTo]="paginatorDropdownAppendTo"
      [dropdownScrollHeight]="paginatorDropdownScrollHeight"
      [templateLeft]="paginatorLeftTemplate"
      [templateRight]="paginatorRightTemplate"
      [currentPageReportTemplate]="currentPageReportTemplate"
      [showFirstLastIcon]="showFirstLastIcon"
      [dropdownItemTemplate]="paginatorDropdownItemTemplate"
      [showCurrentPageReport]="showCurrentPageReport"
      [showJumpToPageDropdown]="showJumpToPageDropdown"
      [showPageLinks]="showPageLinks"
    ></p-paginator>
  }
  <div #sortable_data_view_scroll_panel
    class="h-full overflow-auto p-dataview-content">
    <!-- Dragula -->
    <div class="p-grid p-nogutter grid grid-nogutter"
      [dragula]="draggable ? getDragulaKey('items') : undefined"
      [dragulaModel]="paginator ? (filteredValue || value | slice: (lazy ? 0 : first):(lazy ? 0 : first) + rows) : filteredValue || value"
      (dragulaModelChange)="onNodeMoved.emit({ parent, children: $event })"
      [ngClass]="layout === 'list' ? listStyleClass : gridStyleClass">
      @for (rowData of paginator ? (filteredValue || value | slice: (lazy ? 0 : first):(lazy ? 0 : first) + rows) : filteredValue || value; track trackBy(rowIndex, rowData); let rowIndex = $index) {
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: rowData, rowIndex: rowIndex }"></ng-container>
      }
      @if (IsEmpty && !loading) {
        <div class="p-col col">
          <div class="p-dataview-emptymessage">
            @if (!emptyMessageTemplate) {
              {{ emptyMessageLabel }}
            } @else {
              <ng-container *ngTemplateOutlet="emptyMessageTemplate"></ng-container>
            }
          </div>
        </div>
      }
    </div>
    <!-- -->
  </div>
  @if (paginator && totalRecords > rows && ['bottom', 'both'].includes(paginatorPosition)) {
    <p-paginator
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [pageLinkSize]="pageLinks"
      [alwaysShow]="alwaysShowPaginator"
      (onPageChange)="paginate($event)"
      styleClass="p-paginator-bottom"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [dropdownAppendTo]="paginatorDropdownAppendTo"
      [dropdownScrollHeight]="paginatorDropdownScrollHeight"
      [templateLeft]="paginatorLeftTemplate"
      [templateRight]="paginatorRightTemplate"
      [currentPageReportTemplate]="currentPageReportTemplate"
      [showFirstLastIcon]="showFirstLastIcon"
      [dropdownItemTemplate]="paginatorDropdownItemTemplate"
      [showCurrentPageReport]="showCurrentPageReport"
      [showJumpToPageDropdown]="showJumpToPageDropdown"
      [showPageLinks]="showPageLinks"
    ></p-paginator>
  }
  @if (footer || footerTemplate) {
    <div class="p-dataview-footer">
      <ng-content select="p-footer"></ng-content>
      <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    </div>
  }
</div>